import { Component, Input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-no-data',
  standalone: true,
  imports: [SvgIconComponent],
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
})
export class NoDataComponent {
  @Input() title = 'No Data';
  @Input() desc = 'No data available';
  @Input() icon = '/assets/icon/icon-teacher.svg';
}
